<template>
  <a-modal v-model="visible" :title="`${appData.name}${$t('数据库配置')}`" width="80%" :footer="null" destroyOnClose>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <AppDbEditModal ref="modal" @ok="handleOK" />
  </a-modal>
</template>
<script>
import { getDbList, deleteDbByIds } from '@/api/app/db'
import AppDbEditModal from './AppDbEditModal.vue'

export default {
  components: {
    AppDbEditModal
  },
  data() {
    return {
      visible: false,
      dataSource: [],
      queryParams: {},
      appData: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('数据库类型'),
          dataIndex: 'type'
        },
        {
          title: this.$t('主机'),
          dataIndex: 'host'
        },
        {
          title: this.$t('端口号'),
          dataIndex: 'port'
        },
        {
          title: this.$t('服务名'),
          dataIndex: 'serviceName'
        },
        {
          title: this.$t('数据库'),
          dataIndex: 'db'
        },
        {
          title: this.$t('用户名'),
          dataIndex: 'userName'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
      ]
    }
  },
  methods: {
    show(data) {
      this.appData = { ...data }
      this.dataSource = []
      this.queryParams = {}
      this.pagination.current = 1
      this.pagination.total = 0
      this.refresh()
      this.visible = true
    },
    handleAdd() {
      this.$refs.modal.show(this.appData, {})
    },
    handleEdit(record) {
      this.$refs.modal.show(this.appData, record)
    },
    handleDelete(record) {
      deleteDbByIds([record.id]).then(res => {
        if (res.code === 0) {
          this.refresh()
        } else {
          this.$message.error(res.message || this.$t('删除失败'))
        }
      })
    },
    handleOK(data) {
      if (!data.id) {
        this.pagination.current = 1
      }
      this.refresh()
    },
    refresh() {
        this.loadTableData({ pageNum: this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getDbList(this.appData.id, { ...params, appId: this.appData.id }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    }
  }
}
</script>